// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"zS","category":"zT","tab":"zU","selected":"zV","isRental":"zW"};